import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { closeViewModal } from "../../store/reducers/plantels/plantels.reducer";
import Field from "../UI/Field";
import Loader from "../UI/Loader";
import Modal from "../UI/Modal";
import AuditInfo from "../UI/AuditInfo";

const PlantelViewModal = () => {
  const dispatch = useDispatch();
  const { viewModalOpen, selectedPlantel, selectedPlantelLoading } = useSelector(
    (state) => state.plantels,
  );

  const handleClose = () => {
    dispatch(closeViewModal());
  };

  return (
    <Modal
      open={viewModalOpen}
      title="Detalles del Plantel"
      size="xl"
      onClose={handleClose}
    >
      {selectedPlantelLoading ? (
        <div className="text-center py-5">
          <Loader type="spinner" size="lg" delay={0} />
        </div>
      ) : selectedPlantel ? (
        <div className="row g-4">
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                label="Nombre"
                value={selectedPlantel.nombre}
                icon="mdi:office-building"
              />
              <Field
                label="Clave"
                value={selectedPlantel.clave}
                icon="mdi:identifier"
              />
              <Field
                label="Estado"
                value={
                  selectedPlantel.is_active ? (
                    <span className="badge bg-success-subtle text-success">
                      <Icon
                        icon="mdi:check-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Activo
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger">
                      <Icon
                        icon="mdi:close-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Inactivo
                    </span>
                  )
                }
                icon="mdi:toggle-switch"
              />
              <Field
                label="Configuración de talentos"
                value={
                  selectedPlantel.heredar_configuracion_global ? (
                    <span className="badge bg-info-subtle text-info">
                      <Icon icon="mdi:sync-circle" width="14" height="14" className="me-1" />
                      Hereda configuración global
                    </span>
                  ) : (
                    <span className="badge bg-warning-subtle text-warning">
                      <Icon icon="mdi:cog-outline" width="14" height="14" className="me-1" />
                      Configuración propia
                    </span>
                  )
                }
                icon="mdi:sync"
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                label="Escuela"
                value={selectedPlantel.escuela_nombre}
                icon="mdi:school"
              />
              <Field
                label="Siglas"
                value={selectedPlantel.escuela_siglas}
                icon="mdi:code-tags"
              />
            </div>
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedPlantel.created_at}
              updatedAt={selectedPlantel.updated_at}
              createdBy={selectedPlantel.created_by}
              updatedBy={selectedPlantel.updated_by}
            />
          </div>
        </div>
      ) : (
        <div className="text-center py-5">
          <Icon icon="mdi:alert-circle" width="48" height="48" className="text-muted" />
          <p className="text-muted mt-3">No se pudo cargar la información</p>
        </div>
      )}
    </Modal>
  );
};

export default PlantelViewModal;
